import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Card, Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { getQueries } from 'src/api/admin';
import { CONSTANTS } from 'src/commons';
import CustomTable from 'src/components/Table';
import Toolbar from 'src/components/member/Toolbar';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';
import { debounce } from 'src/utils/debounce';

const Queries = () => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user, gymId } = useSelector((state) => state.common);
  const [queries, setQueries] = useState([]);
  const [page, setPage] = useState(0);
  const [searchLoader, setSearchLoader] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    dispatch(startLoading());
    getQueries(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) setQueries(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const onClickRow = () => {};

  const filterItem = debounce((text) => {
    setSearchInput(text?.trim());
  }, 200);

  const parsedData = useMemo(() => {
    setSearchLoader(true);
    const filteredData = queries?.filter((query) =>
      query.full_name?.toLowerCase()?.includes(searchInput?.toLowerCase())
    );
    setSearchLoader(false);
    return filteredData;
  }, [searchInput, queries]);

  return (
    <>
      <Helmet>
        <title>Queries | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            searchLoader={searchLoader}
            filterItem={filterItem}
            route={CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_QUERY}
            text={'Add Query'}
            hideFilter
          />
          <Box sx={{ pt: 3 }}>
            <Card>
              <CustomTable
                data={parsedData}
                dataKeysSequence={['full_name', 'email', 'phone', 'query_date']}
                headers={['Name', 'Email', 'Phone', 'Query Date']}
                handlePageChange={handlePageChange}
                page={page}
                onClickRow={onClickRow}
              />
            </Card>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Queries;
